import { createContext, useContext } from 'react';

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning';

export interface ToastApi {
  showToast: (message: string, severity?: ToastSeverity) => void;
}

/**
 * Separated from ToastProvider so that file exports only a component, which is
 * what keeps Fast Refresh working during development.
 */
export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return context;
}
